export default "__VITE_ASSET__Ctffzr$l__"